module.exports = __webpack_public_path__ + "media/src/images/icons/actions_email-791774dd431b3946b5ff80a2013aa24f.svg";